export default __webpack_public_path__ + "static/media/pikiro.c07026db.webp";